import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import SlideModal from '@/Atoms/SlideModal';
import CCColors from '@/Utils/CCColors';
import {FontSizes, vs, WINDOW_WIDTH} from '@/Utils/Dimensions';
import * as React from 'react';
import {Text, View, StyleSheet} from 'react-native';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import AntDesign from 'react-native-vector-icons/AntDesign';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';

interface LinkModalProps {
  showConfirm: boolean;
  handleCtaTitle1Press: () => void;
  errorMessage?: string;
  ctaTitle1?: string;
  ctaTitle2?: string;
  handleCtaTitle2Press?: () => void;
  iconImage: React.ReactElement;
  titleText: string;
  description: string;
  highlight1?: boolean;
  highlight2?: boolean;
  handleClose?: () => void;
  backgroundColor?: string;
  borderColor?: string;
}

const LinkModal: React.FC<LinkModalProps> = ({
  showConfirm,
  handleCtaTitle1Press,
  errorMessage,
  ctaTitle1,
  ctaTitle2,
  handleCtaTitle2Press,
  iconImage,
  titleText = 'This is the title',
  description = 'This is the description',
  highlight1,
  highlight2,
  handleClose,
  backgroundColor,
  borderColor,
}) => {
  const {isMobileOrTab} = useMediaQuery();
  return (
    <SlideModal
      minWidth={WINDOW_WIDTH / 4}
      type="center"
      modalHeaderTitle=""
      visible={showConfirm}
      contentPadding={0}
      customStyle={{
        maxWidth: 400,
      }}
      onClose={handleClose}>
      <Box
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        style={styles.container}>
        <Box
          justifyContent="center"
          alignItems="center"
          style={[
            styles.iconWrapper,
            {
              backgroundColor: backgroundColor,
              borderColor: borderColor,
            },
          ]}>
          {iconImage}
        </Box>

        <Box
          marginTop={15}
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={5}
          style={styles.textContainer}>
          <CCText style={styles.text} fontWeight={500} fontSize={FontSizes[16]}>
            {titleText}
          </CCText>
          <CCText
            style={styles.text}
            color={CCColors.Primary.Brown}
            fontWeight={400}
            fontSize={FontSizes[12]}>
            {description}
          </CCText>
        </Box>

        <Box
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={10}
          marginTop={15}>
          {ctaTitle1 && (
            <CCButton
              style={styles.width}
              contentContainerStyle={[
                styles.button,
                {
                  backgroundColor: highlight1
                    ? CCColors.Primary.Default
                    : CCColors.CCTableBg,
                },
              ]}
              onPress={handleCtaTitle1Press}>
              <CCText fontSize={FontSizes[14]} fontWeight={500}>
                {ctaTitle1}
              </CCText>
            </CCButton>
          )}

          {ctaTitle2 && (
            <CCButton
              style={styles.width}
              contentContainerStyle={[
                styles.button,
                {
                  backgroundColor: highlight2
                    ? CCColors.Primary.Default
                    : CCColors.CCTableBg,
                },
              ]}
              onPress={handleCtaTitle2Press}>
              <CCText fontWeight={500} fontSize={FontSizes[14]}>
                {ctaTitle2}
              </CCText>
            </CCButton>
          )}
        </Box>
      </Box>
    </SlideModal>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: 20,
  },
  iconWrapper: {
    height: 70,
    width: 70,
    borderRadius: 40,
    borderWidth: 1,
  },
  textContainer: {
    textAlign: 'center',
    paddingHorizontal: 8,
    flexWrap: 'wrap',
  },
  buttonGroup: {
    width: '100%',
  },
  button: {
    borderRadius: 8,
    paddingVertical: vs(10),
    paddingHorizontal: 0,
  },
  text: {textAlign: 'center', width: '90%'},
  width: {
    minWidth: 250,
    maxWidth: 350,
  },
});

export default LinkModal;
